document.addEventListener("DOMContentLoaded", () => {
  const faqWrappers = document.querySelectorAll(".faq_main");

  faqWrappers.forEach((wrapper) => {
    const faqItems = wrapper.querySelectorAll(".faq_item");

    faqItems.forEach((item) => {
      const question = item.querySelector(".faq_item_que");
      const answer = item.querySelector(".faq_item_ans");

      if (!question || !answer) return;

      // Collapse all initially
      answer.style.height = "0px";

      question.addEventListener("click", () => {
        const isActive = question.classList.contains("active");

        // Close all inside this wrapper
        faqItems.forEach((otherItem) => {
          const otherQuestion = otherItem.querySelector(".faq_item_que");
          const otherAnswer = otherItem.querySelector(".faq_item_ans");
          if (!otherQuestion || !otherAnswer) return;

          otherQuestion.classList.remove("active");
          otherAnswer.classList.remove("active");
          otherAnswer.style.height = "0px";
        });

        // Toggle current
        if (!isActive) {
          question.classList.add("active");
          answer.classList.add("active");
          answer.style.height = answer.scrollHeight + "px";
        }
      });
    });
  });
});